module.exports = __webpack_public_path__ + "static/img/ops-manager-persona.2c7f148.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ops-manager-persona.png
// module id = 562
// module chunks = 1